import { ReadinessItem } from './types';

export const DEFAULT_READINESS: ReadinessItem[] = [
  {
    id: 'fit-justification',
    stage: 'Feasibility Fit',
    item: 'One-line justification for the Strategic Priority / Portfolio picks',
    why: 'Avoids a Send-to-Draft round-trip if either looks borderline.',
    status: 'not_ready',
    note: '',
  },
  {
    id: 'ea-c41',
    stage: 'EA Screening',
    item: 'C4.1 architecture diagram (Ardoq), at least a draft',
    why: 'Most common stall point in this stage.',
    status: 'not_ready',
    note: '',
  },
  {
    id: 'ea-ai-buy-build',
    stage: 'EA Screening',
    item: 'AI use-case description and buy-vs-build stance',
    why: 'Directly requested during screening.',
    status: 'not_ready',
    note: '',
  },
  {
    id: 'ea-external-systems',
    stage: 'EA Screening',
    item: 'List of external systems / integrations involved',
    why: 'Directly requested during screening.',
    status: 'not_ready',
    note: '',
  },
  {
    id: 'ea-data-class',
    stage: 'EA Screening',
    item: 'Data classification / personal-information handling notes',
    why: 'Directly requested during screening.',
    status: 'not_ready',
    note: '',
  },
  {
    id: 'proc-new-spend',
    stage: 'Procurement / Ops Screening',
    item: 'Clarity on new spend vs an existing vendor / contract',
    why: 'Determines screening path.',
    status: 'not_ready',
    note: '',
  },
  {
    id: 'proc-resourcing',
    stage: 'Procurement / Ops Screening',
    item: 'Confirm Q23 resourcing source is accurate',
    why: 'Procurement cross-checks this field directly.',
    status: 'not_ready',
    note: '',
  },
  {
    id: 'final-conditional',
    stage: 'Final Approval',
    item: 'Know Conditional Requirements may attach after the vote',
    why: 'They carry forward onto the Demand record.',
    status: 'not_applicable',
    note: '',
  },
];
